module.exports = window["__sharedReduxPersist"];